import React from "react";
import { useTranslation } from "react-i18next";

const RegisterHeading = () => {
  const { t } = useTranslation();
  return (
    <div className={`content_plain`}>
      <h1>{t("content.homeFormTitle")}</h1>
      <h4 className="lato">{t("content.homeFormSubtitle")}</h4>
    </div>
  );
};

export default RegisterHeading;
